import React from 'react';
import { Divider, Menu } from 'antd';
import './index.css';

const ContextMenu = ({ record, visible, x, y, children }) => {
  return (
    visible && (
      <ul className="popup" style={{ left: `${x}px`, top: `${y}px` }}>
        {children}
      </ul>
    )
  );
};

export default ContextMenu;
